import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Input } from "@my-scoot/component-library-legacy";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { notification_color_keys } from "utils/hooks";
import { useNotify } from "react-admin";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import {
  GRACE_PEROID_VALIDATION_CONSTANTS,
  MANAGE_SUBSCRIPTIONS_KEYS,
} from "../../constants/Subscriptions.constants";
import { useFetchListingDetails } from "features/Listings/utils/useFetchListingDetails";

export const ManageGracePeriodSwitch = ({ subSectionKey }) => {
  const notify = useNotify();
  const isDesktop = useDesktopMediaQuery();
  const { listing_uuid } = useParams();
  const { fetchListingDetails } = useFetchListingDetails();
  const { handleSectionChange } = useAccountSectionUnlocking();
  const [listingData, setListingData] = useState({});
  const [value, setValue] = useState(null);
  const [isGracePeriodAllowed, setIsGracePeriodAllowed] = useState(value);
  const [inputValue, setInputValue] = useState(null);
  const [error, setError] = useState({
    err: false,
    helperText: null,
  });

  const handleSectionValueChange = (feature_value) => {
    const payload = {
      listing_uuid,
      feature_key: MANAGE_SUBSCRIPTIONS_KEYS.GRACE_PERIOD,
      feature_value: feature_value,
    };
    handleSectionChange({
      endPoint: UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
      payload,
    });
  };
  const handleChange = () => {
    if (!value) setIsGracePeriodAllowed(true);
    else setIsGracePeriodAllowed(false);
    handleSectionValueChange(
      !value ? GRACE_PEROID_VALIDATION_CONSTANTS.DEFAULT : null
    );
    setValue(!value);
    setInputValue(!value ? GRACE_PEROID_VALIDATION_CONSTANTS.DEFAULT : null);
  };

  const handleInputChange = (val) => {
    if (val <= GRACE_PEROID_VALIDATION_CONSTANTS.MAX_LIMIT) {
      setInputValue(val);
      if (val) {
        setError({ err: false, helperText: null });
        handleSectionValueChange(val);
      } else {
        setError({ err: true, helperText: "Required" });
      }
    } else {
      notify(
        `Value more than ${GRACE_PEROID_VALIDATION_CONSTANTS.MAX_LIMIT} days is not allowed`,
        notification_color_keys.error
      );
    }
  };

  useEffect(() => {
    async function getData() {
      setListingData(
        await fetchListingDetails({
          listingUuid: listing_uuid,
          forceFetch: true,
        })
      );
    }
    getData();
  }, []);

  useEffect(() => {
    if (Object.keys(listingData).length) {
      setValue(listingData?.metadata?.[subSectionKey]);
      setIsGracePeriodAllowed(
        listingData?.metadata?.[subSectionKey] ? true : false
      );
      setInputValue(
        typeof parseInt(listingData?.metadata?.[subSectionKey]) !== "number"
          ? GRACE_PEROID_VALIDATION_CONSTANTS.DEFAULT
          : listingData?.metadata?.[subSectionKey]
      );
    }
  }, [listingData]);

  return (
    <div className="tw-flex tw-items-center">
      <SectionUnlockingSwitch value={value} onChange={handleChange} />
      {isGracePeriodAllowed && (
        <span className="tw-flex tw-justify-center tw-items-center">
          <Input
            value={inputValue}
            onChange={({ target: { value } }) => handleInputChange(value)}
            inputClassName="tw-bg-white"
            wrapperClassName={
              !isDesktop ? "w-100 !tw-mt-[-4px]" : "tw-w-[35%] "
            }
            error={error.err}
            helperText={error.helperText}
            fullWidth
          />
          <p className="!tw-ml-[10px] tw-text-[16px] tw-font-medium"> Days </p>
        </span>
      )}
    </div>
  );
};
